<template>
	<v-container grid-list-md class="pa-0">
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-layout row wrap>
					<v-flex xs12>
						<filter-reservation
							v-model="filter"
							:outlets="outlets"
							:customers="customers"
							@filter="onFilter()"
						></filter-reservation>
					</v-flex>
					<v-flex xs12>
						<app-datatable
							:title="$t('title.reservations_datatable')"
							:printUrl="
								$route(
									'tenant.reservations.print.index',
									$page.props.tenant.id,
									{
										params: {
											'filter[status]':
												this.filter.status,
											'filter[code]': this.filter.code,
											'filter[outlet]':
												this.filter.outlet,
											'filter[customer]':
												this.filter.customer,
										},
									}
								)
							"
							:exportUrl="
								$route(
									'tenant.reservations.export.reservation',
									$page.props.tenant.id
								)
							"
							:endpoint="endpoint"
							:data="data"
							:headers="headers"
							:filter="filter"
							@onEdit="editItem"
							@onDelete="deleteItem"
							@onView="viewItem"
						>
						</app-datatable>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>

		<app-create-fab-button
			@click="
				$inertia.visit(
					$route('tenant.reservations.create', $page.props.tenant.id)
				)
			"
			:permission="'create reservations'"
		></app-create-fab-button>

		<app-tenant-delete-dialog
			ref="deleteDialog"
			:endpoint="'tenant.reservations.destroy'"
			:uuid="item.uuid"
			:data="{
				reservation: item.uuid,
				tenant: $page.props.tenant.id,
			}"
		></app-tenant-delete-dialog>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import pickBy from "lodash/pickBy";
import TenantReservationMenu from "@Reservation/components/TenantReservationMenu.vue";
import TenantLayout from "@/layouts/tenant.vue";
import TenantReservationLayout from "@Reservation/layouts/reservation_layout.vue";
import moment from "moment";
export default {
	layout: [TenantLayout, TenantReservationLayout],
	props: ["data", "outlets", "customers"],
	data() {
		return {
			panel: [0],
			filter: {
				range: {
					startDate: new moment().format("YYYY-MM-DD"),
					endDate: new moment().format("YYYY-MM-DD"),
				},
			},
			item: {},
		};
	},
	components: {
		Link,
		TenantReservationMenu,
	},
	computed: {
		endpoint() {
			return this.$route(
				"tenant.reservations.index",
				this.$page.props.tenant.id
			);
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					width: 80,
					align: "left",
					sortable: false,
				},

				{
					text: this.$t("Customer"),
					value: "customer_name",
					align: "start",
					sortable: false,
					width: 150,
				},
				{
					text: this.$t("Outlet"),
					value: "outlet_name",
					align: "start",
					sortable: false,
					width: 150,
				},
				{
					text: this.$t("Date"),
					value: "date",
					align: "start",
					sortable: false,
					width: 150,
				},
				{
					text: this.$t("Time"),
					value: "time",
					sortable: false,
					searchable: false,
					with: 150,
				},
				{
					text: this.$t("label.adults"),
					value: "adults",
					align: "start",
					sortable: false,
					searchable: false,
					with: 150,
				},
				{
					text: this.$t("label.children"),
					value: "children",
					sortable: false,
					searchable: false,
					align: "start",
					width: 150,
				},
				{
					text: this.$t("label.comment"),
					value: "description",
					sortable: false,
					searchable: false,
					width: 250,
				},
				{
					text: this.$t("Status"),
					value: "status",
					sortable: false,
					searchable: false,
					width: 150,
				},
			];
		},
	},
	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
		editItem(item) {
			this.$inertia.get(
				this.$route("tenant.reservations.edit", {
					tenant: this.$page.props.tenant.id,
					reservation: item.uuid,
				})
			);
		},
		viewItem(item) {
			this.$inertia.get(
				this.$route("tenant.reservations.show", {
					tenant: this.$page.props.tenant.id,
					reservation: item.uuid,
				})
			);
		},
		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>